import axios from 'axios';

// Create axios interceptor to add user ID header to all requests
axios.interceptors.request.use(
  (config) => {
    // Get user from localStorage
    const userInfo = localStorage.getItem('user');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user && user.id) {
          // Add user ID to headers for logging purposes
          config.headers['X-User-ID'] = user.id;
        }
      } catch (error) {
        console.warn('Failed to parse user info from localStorage:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
